'use client';

import BlogCard from '@/components/BlogCard';
import HorizontalSlider from '@/components/HorizontalSlider';
import SliderSection from '@/components/SliderSection';
import { BlogPost } from '@/types/blog.type';

import styles from './RelatedBlogsSection.module.scss';

interface RelatedBlogsSectionProps {
  title: string;
  posts: BlogPost[];
  currentSlug: string;
}

const RelatedBlogsSection = ({ title, posts, currentSlug }: RelatedBlogsSectionProps) => {
  const filteredPosts = posts.filter(post => post.slug !== currentSlug);

  if (filteredPosts.length === 0) {
    return null;
  }

  return (
    <SliderSection title={title} customStyles={{ container: styles.container }}>
      {handleSwiper => (
        <HorizontalSlider
          data={filteredPosts}
          handleSwiper={handleSwiper}
          customStyles={{ slide: styles.slide }}
          renderItem={(post: BlogPost) => (
            <BlogCard
              slug={post.slug}
              image={post.cardImage}
              imageAlt={post.title}
              date={post.date}
              readTime={post.readTime}
              title={post.title}
              author={post.author}
            />
          )}
        />
      )}
    </SliderSection>
  );
};

export default RelatedBlogsSection;
